import * as React from 'react';
import { Image, useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';
import img from './assets/success.png';
import { Typography } from '../../../Typography';
import { Button } from '../../../Button';

export interface ISuccessScreenProps {
  onClose: () => void;
}

export const SuccessScreen: React.FC<ISuccessScreenProps> = ({ onClose }) => {
  const deviceType = useDeviceType();

  return (
    <div className={styles.content}>
      <div className={styles.text}>
        <Typography.Title level={deviceType === 'desktop' ? 3 : 5}>Отклик отправлен</Typography.Title>
        <Typography.Text level={deviceType === 'desktop' ? 2 : 3}>Свяжемся с вами в ближайшее время</Typography.Text>
      </div>

      <Image
        src={img}
        width={deviceType === 'desktop' ? 668 : '100%'}
        height={deviceType === 'desktop' ? 468 : 'auto'}
      />

      <div className={styles.ok}>
        <Button onClick={onClose} fullWidth>
          Супер
        </Button>
      </div>
    </div>
  );
};
